import React from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

type MaintenanceState = {
  active: boolean;
  endsAt?: number | null;
};

const formatRemaining = (ms: number): string => {
  if (ms <= 0) return '0:00';
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

const MaintenanceOverlay: React.FC = () => {
  const [state, setState] = React.useState<MaintenanceState>({ active: false, endsAt: null });
  const [now, setNow] = React.useState<number>(Date.now());

  // Poll backend every 5s
  React.useEffect(() => {
    let cancelled = false;
    const fetchStatus = async () => {
      try {
        const res = await fetch('/api/maintenance', { credentials: 'include' });
        const data = await res.json();
        if (!cancelled) setState({ active: !!data?.active, endsAt: typeof data?.endsAt === 'number' ? data.endsAt : null });
      } catch {
        // ignore
      }
    };
    fetchStatus();
    const iv = setInterval(fetchStatus, 5000);
    return () => { cancelled = true; clearInterval(iv); };
  }, []);

  // Ticker to update countdown every 500ms
  React.useEffect(() => {
    const iv = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(iv);
  }, []);

  if (!state.active) return null;

  const remainingMs = (state.endsAt ?? 0) - now;
  const remaining = formatRemaining(remainingMs);

  return (
    <Backdrop open sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1000 }}>
      <Box sx={{ textAlign: 'center', p: 3 }}>
        <Typography variant="h4" component="div" sx={{ mb: 2 }}>
          Aktualizacja w toku
        </Typography>
        <Typography variant="h6" component="div" sx={{ mb: 3 }}>
          Zakończenie za około {remaining} min.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
          <CircularProgress color="inherit" />
          <Box>
            <Typography variant="body1">Odświeżenie nastąpi automatycznie po zakończeniu.</Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>Przepraszamy za utrudnienia</Typography>
          </Box>
        </Box>
      </Box>
    </Backdrop>
  );
};

export default MaintenanceOverlay;


